@import '~style-sheet-helpers/core.less';
@import '../../../../constants/screen-width-breakpoints.module.less';
@import (reference) '../../../../constants/spacing.module.less';

.container {
  width: 100%;

  .label {
    font-size: 12px;
    display: flex;
    align-items: baseline;
    gap: 2px;

    &.error {
      color: var(--red-700);
    }
  }

  .required-asterisk {
    color: var(--red-650);
  }

  .toggler {
    padding: @space-4 @space-8;
  }
}

.dropdown-menu {
  display: block;
  margin-top: 4px;
  height: 42px;
  width: 100%;
}

.state-input {
  border: 0;
  padding: 0;
  height: 22px;

  @media @mobile {
    font-size: 16px;
  }
}
